import axios from 'axios';
import Cookies from 'js-cookie';
import { roomPriceHeaders } from './roomPriceContext';

export default async function callApi({
  baseURL,
  endpoint,
  method = 'GET',
  data,
  headers,
  params,
  signal,
}) {
  try {
    // const base = 'https://designv3-prod.lanha.vn/';
    const base = baseURL ?? process.env.REACT_APP_API_URL_V3;
    if (base) {
      const accessToken = baseURL ? null : Cookies.get('access_token');
      let newHeaders = {};
      if (accessToken) newHeaders.Authorization = 'Bearer ' + accessToken;
      newHeaders = { ...newHeaders, ...roomPriceHeaders(endpoint), ...headers };
      return await axios({
        method: method,
        url: `${base}${endpoint}`,
        data: data,
        headers: newHeaders,
        params: params,
        signal: signal,
      });
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        throw error.response;
      } else if (error.request) {
        // console.error("Request Made:", error.request);
        throw error.request;
      } else {
        // console.error("Error Message:", error.message);
        throw error.message;
      }
    } else {
      throw error;
    }
  }
}
